import React from 'react';
import { Container,Card, CardBody } from 'reactstrap';

const CurrentUserProfile = () => {
    return (
        <Container>
          <Card className='m-0'>
            <CardBody>
              My profile
            </CardBody>
          </Card>
        </Container>
      )
}
 
export default CurrentUserProfile;